import React from 'react';
import { Tabs, Icon, Tag } from 'antd';
const TabPane = Tabs.TabPane;
import { observer, inject } from 'mobx-react';
import SearchForm from '../../components/DeviceInfo/DeviceInfoSearchForm';
import styles from './DeviceInfo.less';
import DeviceDetail from '../../components/DeviceInfo/DeviceDetail';
import DeviceMonitor from '../../components/DeviceInfo/DeviceMonitor';
import DeviceApp from '../../components/DeviceInfo/DeviceApp';
import DeviceControl from '../../components/DeviceInfo/DeviceControl';
import DeviceConnect from '../../components/DeviceInfo/DeviceConnect';
import OnOffline from '../../components/DeviceInfo/OnOffline';
import notFound from '../../media/imgs/notFound.png';
import searching from '../../media/imgs/searching.png';
import { SENIOR } from '../../const/Auth';
@inject('deviceInfoStore', 'deviceInfoDetailStore', 'loginStore')
@observer
class DeviceInfo extends React.Component {
  state = {
    activeKey: '1'
  };

  componentDidMount() {
    const deviceId = this.props.match.params.id;
    this.loadData(deviceId);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.match.params.id !== this.props.match.params.id) {
      this.setAvtiveKey('1');
      const deviceId = nextProps.match.params.id;
      this.loadData(deviceId);
    }
  }

  setAvtiveKey = key => {
    this.setState({
      activeKey: key
    });
  };

  loadData = deviceId => {
    if (deviceId) {
      this.props.deviceInfoStore.deviceId = deviceId;
      this.props.deviceInfoDetailStore.loadDeviceDetail(deviceId);
    }
  };

  render() {
    const { deviceDetail, deviceLoading } = this.props.deviceInfoDetailStore;
    const { authority } = this.props.loginStore;
    return (
      <div className={styles.deviceInfo}>
        <div className={styles.searchContainer}>
          <SearchForm key={this.props.deviceInfoStore.deviceId} />
        </div>
        {this.props.deviceInfoStore.deviceId &&
          deviceDetail.device_id && (
            <div className={styles.bottomContainer}>
              <div className={styles.title}>
                <div>
                  <span>设备编号:</span>&nbsp;&nbsp;
                  <span>{this.props.deviceInfoStore.deviceId}</span>
                </div>
                <div className={styles.iconContainer}>
                  {deviceDetail.online_status === 1 ? (
                    <Tag color="green">在线</Tag>
                  ) : (
                    <Tag color="red">离线</Tag>
                  )}
                </div>
              </div>
              <div className={styles.tabsContainer}>
                <Tabs
                  activeKey={this.state.activeKey}
                  onChange={this.setAvtiveKey}
                >
                  <TabPane tab="设备详情" key="1">
                    <DeviceDetail />
                  </TabPane>
                  <TabPane tab="监控详情" key="2">
                    <DeviceMonitor />
                  </TabPane>
                  <TabPane tab="在线/离线统计" key="6">
                    <OnOffline />
                  </TabPane>
                  <TabPane tab="App详情" key="3">
                    <DeviceApp />
                  </TabPane>
                  <TabPane tab="远程控制" key="4">
                    <DeviceControl />
                  </TabPane>
                  {authority === SENIOR && (
                    <TabPane tab="远程连接" key="5">
                      <DeviceConnect />
                    </TabPane>
                  )}
                </Tabs>
              </div>
            </div>
          )}
        {(!this.props.deviceInfoStore.deviceId ||
          !deviceDetail['device_id']) && (
          <div className={styles.nullContainer}>
            {deviceLoading ? (
              <div className={styles.textContainer}>
                <img src={searching} />
                正在搜索中
                <div className={styles.spinner}>
                  <div className={styles.bounce1} />
                  <div className={styles.bounce2} />
                  <div className={styles.bounce3} />
                </div>
              </div>
            ) : (
              <div className={styles.textContainer}>
                {' '}
                <img src={notFound} /> 找不到设备
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}
export default DeviceInfo;



// WEBPACK FOOTER //
// ./src/pages/DeviceInfo/DeviceInfo.js